import { Component, OnInit } from '@angular/core';
import {  Router } from '@angular/router';
import { ViewWillEnter } from '@ionic/angular';

@Component({
  selector: 'app-view-order-header',
  templateUrl: 'header.component.html',
  styleUrls: [
    './header.component.scss',
  ],
})
export class ViewOrderHeaderComponent implements ViewWillEnter, OnInit {

    orderId: number = null;

    data: any[] = [];

    loaded: boolean = false;

    constructor(
        private router: Router,
    ) { 

    }

    ngOnInit(): void {

    }

    ionViewWillEnter(): void {

    }

    navigateHome(): void {
        this.router.navigate(['']);
    }

}